import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)

var language = JSON.parse(window.localStorage.getItem("language")) || 0

/** 同浏览器、同域名下 WebSocket 互斥锁（避免二级页抢连踢掉首页） */
var WS_LOCK_KEY = 'djx_ws_owner_lock'
/** 心跳有效期（毫秒），超时视为持有页已关闭 */
var WS_LOCK_TTL = 15000
/** 是否已绑定页面卸载释放锁 */
var wsUnloadBound = false
/** 卸载时回调（指向当前持有连接的释放逻辑） */
var wsUnloadHandler = null

/**
 * 当前标签页唯一 ID
 * @returns {string}
 */
function getWsTabId() {
	if (!window.__djxWsTabId) {
		window.__djxWsTabId =
			'tab_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
	}
	return window.__djxWsTabId
}

/**
 * 读取锁信息
 * @returns {{tabId: string, ts: number, origin: string}|null}
 */
function readWsLock() {
	try {
		return JSON.parse(window.localStorage.getItem(WS_LOCK_KEY) || 'null')
	} catch (e) {
		return null
	}
}

/**
 * 锁是否仍有效（同域且未超时）
 * @param {{tabId: string, ts: number, origin: string}|null} lock
 * @returns {boolean}
 */
function isWsLockAlive(lock) {
	if (!lock || !lock.tabId || !lock.ts) return false
	if (lock.origin && lock.origin !== window.location.origin) return false
	return Date.now() - lock.ts < WS_LOCK_TTL
}

/**
 * 写入/刷新本页持有的锁
 */
function writeWsLock() {
	try {
		window.localStorage.setItem(
			WS_LOCK_KEY,
			JSON.stringify({
				tabId: getWsTabId(),
				ts: Date.now(),
				origin: window.location.origin,
			})
		)
	} catch (e) {}
}

/**
 * 若本页持有锁则释放
 */
function releaseWsLockIfOwner() {
	try {
		var lock = readWsLock()
		if (lock && lock.tabId === getWsTabId()) {
			window.localStorage.removeItem(WS_LOCK_KEY)
		}
	} catch (e) {}
}

/**
 * 尝试占用连接锁；他页已占用则返回 false
 * @returns {boolean}
 */
function tryAcquireWsLock() {
	var lock = readWsLock()
	var myId = getWsTabId()
	if (!lock || !isWsLockAlive(lock) || lock.tabId === myId) {
		writeWsLock()
		return true
	}
	return false
}

/**
 * 当前是否由其他同域标签页持有连接
 * @returns {boolean}
 */
function isWsOwnedByOtherTab() {
	var lock = readWsLock()
	return !!(lock && isWsLockAlive(lock) && lock.tabId !== getWsTabId())
}

export default new vuex.Store({
	state: {
		websock: null, //websock对象
		websockUrl: WEBSOCKETSEVERS + '?token=',
		websockBtn: 1,
		websockTimer: null,
		websockLockTimer: null,
		/** 主动关闭（登出等），不弹重连框 */
		websockClosingIntentional: false,
		/** 连接由同域其他标签页持有，本页不建连 */
		websockOwnedByOtherTab: false,
		language: language,
		nowCaseItem: {},
		workBtn: false,
		workImgBox: {
			url: '',
			status: false,
		},
		websockList: [],
		caseId: '',
	},
	mutations: {
		websockStore(state, token) {
			/**
			 * 页面卸载时释放锁，便于其他同域页接管
			 */
			function onPageUnload() {
				if (state.websock) {
					state.websockClosingIntentional = true
				}
				releaseWsLockIfOwner()
				if (state.websockLockTimer) {
					clearInterval(state.websockLockTimer)
					state.websockLockTimer = null
				}
			}

			/**
			 * 绑定一次 beforeunload / pagehide
			 */
			function bindUnloadOnce() {
				wsUnloadHandler = onPageUnload
				if (wsUnloadBound) return
				wsUnloadBound = true
				window.addEventListener('beforeunload', function () {
					if (wsUnloadHandler) wsUnloadHandler()
				})
				window.addEventListener('pagehide', function () {
					if (wsUnloadHandler) wsUnloadHandler()
				})
			}

			/**
			 * 启动锁心跳，声明本页仍持有连接
			 */
			function startLockHeartbeat() {
				if (state.websockLockTimer) {
					clearInterval(state.websockLockTimer)
				}
				writeWsLock()
				state.websockLockTimer = setInterval(function () {
					writeWsLock()
				}, 5000)
				bindUnloadOnce()
			}

			/**
			 * 停止锁心跳
			 */
			function stopLockHeartbeat() {
				if (state.websockLockTimer) {
					clearInterval(state.websockLockTimer)
					state.websockLockTimer = null
				}
			}

			if (token == null) {
				state.websockClosingIntentional = true
				stopLockHeartbeat()
				releaseWsLockIfOwner()
				if (state.websock) {
					try {
						state.websock.close()
					} catch (e) {}
				}
				clearInterval(state.websockTimer)
				state.websock = null
				state.websockOwnedByOtherTab = false
				console.log('websocket 连接关闭！')
				return
			}

			// 本页已连接或正在连接，无需重复建连（刷新锁，防止二级页误抢）
			if (
				state.websock &&
				(state.websock.readyState === WebSocket.OPEN ||
					state.websock.readyState === WebSocket.CONNECTING)
			) {
				writeWsLock()
				if (!state.websockLockTimer) {
					state.websockLockTimer = setInterval(function () {
						writeWsLock()
					}, 5000)
					bindUnloadOnce()
				}
				return
			}

			// 同浏览器、同域名下已有其他页持有连接：本页（如二级页）不新建，避免踢掉首页
			if (!tryAcquireWsLock()) {
				state.websockOwnedByOtherTab = true
				console.log('websocket 由同域其他标签页持有，本页跳过建连')
				return
			}

			state.websockOwnedByOtherTab = false
			// init()

			/**
			 * 建立 WebSocket
			 */
			function init() {
				if (!tryAcquireWsLock()) {
					state.websockOwnedByOtherTab = true
					state.websock = null
					return
				}
				state.websockOwnedByOtherTab = false
				state.websock = new WebSocket(state.websockUrl + token)
				state.websock.onopen = function () {
					websocketopen()
				}
				state.websock.onclose = websocketclose
				state.websock.onerror = websocketclose
			}

			/**
			 * 连接成功
			 */
			function websocketopen() {
				console.log('连接成功')
				startLockHeartbeat()
				websocketSendHeart()
			}

			/**
			 * 心跳保活
			 */
			function websocketSendHeart() {
				var data = {
					type: 'user',
					actType: 4,
				}
				if (state.websockTimer) {
					clearInterval(state.websockTimer)
				}
				state.websockTimer = setInterval(function () {
					if (state.websock && state.websock.readyState === WebSocket.OPEN) {
						state.websock.send(JSON.stringify(data))
					}
				}, 5000)
			}

			/**
			 * 连接关闭
			 */
			function websocketclose() {
				console.log('WebSocket关闭')
				clearInterval(state.websockTimer)
				stopLockHeartbeat()
				state.websockBtn = state.websockBtn + 1

				// 主动关闭（登出 / 页面卸载）不弹窗
				if (state.websockClosingIntentional) {
					state.websockClosingIntentional = false
					state.websock = null
					return
				}

				// 同域其他标签页已接管连接：首页被踢时静默，不弹「是否重新连接」
				if (isWsOwnedByOtherTab()) {
					state.websock = null
					state.websockOwnedByOtherTab = true
					releaseWsLockIfOwner()
					console.log('websocket 已由同域其他页接管，跳过重连弹窗')
					return
				}

				// 仅【测试环境】监管机构不弹窗
				try {
					var isTestEnv =
						window.SEVSRS && String(window.SEVSRS).includes('test')
					var usertype = JSON.parse(
						window.localStorage.getItem('usertype') || '{}'
					).data
					if (isTestEnv && usertype === 2) return
				} catch (e) {}

				var languageName = ''
				if (state.language == 0) {
					languageName = '连接已断开，是否重新连接?'
				} else {
					languageName =
						'The connection has been disconnected. Do you want to reconnect?'
				}
				var r = confirm(languageName)
				if (r) {
					init()
				} else {
					releaseWsLockIfOwner()
					state.websock = null
				}
			}
		},
		languageFun(state, index) {
			state.language = index
		},
		workData(state, data) {
			console.log(state)
			state.nowCaseItem = data
		},
		workBtnFun(state, status) {
			state.workBtn = status
		},
		workImgBoxFun(state, obj) {
			state.workImgBox = obj
		},
		websockListFun(state, list) {
			if (list) {
				state.websockList.push(list)
			} else {
				state.websockList = []
			}
		},
		caseIdFun(state, id) {
			state.caseId = id
		},
	},
})



// WEBPACK FOOTER //
// ./src/store/index.js